import {Injectable} from '@angular/core';
import {ReportesRequestService} from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})

export class ServicioCarteraPacienteService {

  constructor( private requestUrl: ReportesRequestService ) { }

  async getCarteraPaciente(codigoBaseDatos: String, ld_fec_ini: Date, ld_fec_fin: Date) {
    try {
      return await this.requestUrl.getRequest('carteraPaciente/carteraPaciente',
      [codigoBaseDatos, {ld_fec_ini, ld_fec_fin}]);
    } catch (e) {
      console.error(`ServicioCarteraPacienteService.getCarteraPaciente() ${e}`);
    }
    return null;
  }

}

export interface CarteraPacienteEntity {

  captador: string;
  paciente: string;
  asistio: string;
  identificacionPaciente: string;
  tipo_identificacion_paciente: string;

  fechaCita: Date;

  valorPago: number;
  valorPagado: number;
  saldo: number;
}
